import { render, staticRenderFns } from "./KarenSettings.vue?vue&type=template&id=d2442594&scoped=true&"
import script from "./KarenSettings.vue?vue&type=script&lang=js&"
export * from "./KarenSettings.vue?vue&type=script&lang=js&"
import style0 from "./KarenSettings.vue?vue&type=style&index=0&id=d2442594&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2442594",
  null
  
)

export default component.exports